import React, { useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import LoadingImage from '../../LoadingImage';
import Delimiter from '../../Delimiter';
import Dropdown from '../../Dropdown';
import UserDropdownToggle from './UserDropdownToggle';
import { logout } from '../../../../requests';
import { NAVIGATE_PATH } from '../../../../helpers/constants';
import {
  useAppDispatch,
  useAppSelector,
  useDropdown,
} from '../../../../hooks/hooks';
import { companyLogo, userAvatar } from '../../../../helpers';
import { clearCart } from '../../../../store/reducers/userSlice';
import { UserRole } from '../../../../models/IUser';

const UserDropdown: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user, isManager } = useAppSelector((state) => state.userReducer);
  const [isOpen, setIsOpen] = useState(false);
  const { handleDropdownToggle, dropdownRef } = useDropdown(isOpen, setIsOpen);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(clearCart());
    logout().then(() => navigate(NAVIGATE_PATH.login, { replace: true }));
  };

  return (
    <Dropdown
      isOpen={isOpen}
      handleDropdownToggle={handleDropdownToggle}
      dropdownRef={dropdownRef}
      maxHeight="16rem"
      toggle={<UserDropdownToggle />}
    >
      <div className="flex flex-col w-64 gap-1 p-2 font-medium text-regular text-core-dark">
        <div className="gap-4 p-0 pointer-events-none dropdown-item">
          <LoadingImage src={userAvatar(user)} className="avatar" />
          <div className="font-bold grow">
            {user?.firstName} {user?.lastName}
          </div>
        </div>
        <Link className="dropdown-item" to={NAVIGATE_PATH.profileSettings}>
          <div>Profile settings</div>
        </Link>
        <Delimiter />
        {!user?.individual && (
          <>
            <div className="gap-4 p-0 pointer-events-none dropdown-item">
              <LoadingImage
                className="w-8 h-8 rounded-lg"
                src={companyLogo(user?.company)}
              />
              <div className="font-bold grow">{user?.company.name}</div>
            </div>
            <Link
              className="dropdown-item"
              to={
                isManager
                  ? NAVIGATE_PATH.companySettings
                  : NAVIGATE_PATH.companyInfo
              }
            >
              <div>Company {isManager ? 'settings' : 'info'}</div>
            </Link>
            {(user?.role === UserRole.MANAGER ||
              user?.role === UserRole.ADMIN) && (
              <a
                href="https://www.learnitadminportal.com/s/login"
                className="dropdown-item"
                target="_blank"
              >
                Admin Portal
              </a>
            )}
          </>
        )}
        <div className="dropdown-item" onClick={handleLogout}>
          <div>Log out</div>
        </div>
      </div>
    </Dropdown>
  );
};

export default UserDropdown;
